import { useNavigate } from 'react-router-dom';
import s from './Header.module.scss';

export default function Header() {
    const navigate = useNavigate();

    const logout = () => {
        localStorage.removeItem('admin_token');
        navigate('/login', { replace: true });
    };

    return (
        <header className={s.header}>
            <div className={s.left}>
                <div className={s.logoIcon}>RS</div>
                <div className={s.logoText}>
                    <span className={s.logoMain}>ResumeScan</span>
                    <span className={s.logoSub}>Admin Panel</span>
                </div>
            </div>
            <div className={s.right}>
                <button className={s.logoutBtn} onClick={logout}>
                    Выйти
                </button>
            </div>
        </header>
    );
}
